import { styled } from 'styled-components'

export const StyledProfilePic = styled.img`
  width: 180px;
  height: 180px;
  border: 0.5px solid ${({ theme }) => theme.colors.palette.lightBlack};
  border-radius: 50%;
  box-shadow: 0 0 20px 10px ${({ theme }) => theme.colors.palette.darkBlack};
`

export const StyledLinkContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);  // two columns
  gap: 1.8em;
`
